import axios from "axios";
import Cookies from "js-cookie";
import {
  toast
} from "react-toastify";
import {
  logout
} from "../actions/auth";
import {
  API_URL
} from "../utils/constant";

const baseURL = API_URL;
const TOKEN_KEY = "access_token";

export default {
  setupInterceptors: (store, history) => {
    const TIMEOUT = 10 * 60 * 1000;
    axios.defaults.timeout = TIMEOUT;
    axios.defaults.baseURL = baseURL;
    axios.defaults.headers = {
      "Content-Type": "application/json; charset=utf-8",
      Accept: "application/json; charset=utf-8"
    };

    axios.interceptors.request.use(
      config => {
        if (!config.url.includes("/auth/login")) {
          config.headers["Authorization"] = "Bearer " + Cookies.get(TOKEN_KEY);
        }
        return config;
      },
      error => {
        // 对请求错误做些什么
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      response => {
        return response;
      },
      error => {
        const status =
          error.status || (error.response ? error.response.status : 0);

        switch (status) {
          case 400:
            console.error("请求错误");
            break;

          case 401:
            error.message = "Please log in";
            store.dispatch(logout('401'));
            break;

          case 403:
            console.error("拒绝访问");
            break;

          case 404:
            console.error(`请求地址出错: ${error.response.config.url}`);
            break;

          case 408:
            console.error("请求超时");
            break;

          case 429:
            console.error("429 Too Many Requests");
            break;

          case 500:
            console.error("服务器内部错误");
            break;

          case 501:
            console.error("服务未实现");
            break;

          case 502:
            console.error("网关错误");
            break;

          case 503:
            console.error("服务不可用");
            break;

          case 504:
            console.error("网关超时");
            break;

          case 505:
            console.error("HTTP版本不受支持");
            break;

          default:
            console.error("未知错误");
            break;
        }

        if (status !== 401) {
          toast.warn(error.message);
        }
        return Promise.reject(error);
      }
    );
  }
};